<template>
  <div class="website-external-wrapper">
    <div class="full-area padded vertically-centered">
      <SensataSplash v-if="canRender"></SensataSplash>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Logo',

  transition: 'page',

  components: {
    SensataSplash: () => import('Components/base/SensataSplash')
  },

  data () {
    return {
      canRender: false
    }
  },

  mounted () {
    setTimeout(() => {
      this.canRender = true
    }, 2000)
  },

  metaInfo () {
    var ogTitle = ''
    var ogDescription = ''
    var ogImage = ''

    var a = this.siteContent[window.location.pathname]
    if (a && a.fields) {
      ogTitle = a.fields.ogTitle
      ogDescription = a.fields.ogDescription
      if (a.fields.ogImage) {
        ogImage = a.fields.ogImage.fields.file.url
      }
    }
    return {
      title: ogTitle,
      meta: [
        { vmid: "og:url", property: "og:url", content: `${process.env.VUE_APP_BASE_URL}` },
        { vmid: "description", name: "description", content: ogDescription },
        { vmid: "og:title", property: "og:title", content: ogTitle },
        { vmid: "og:description", property: "og:description", content: ogDescription },
        { vmid: "twitter:card", property: "twitter:card", content: "summary_large_image" },
        { vmid: "og:image:width", property: "og:image:width", content: "1200" },
        { vmid: "og:image:height", property: "og:image:height", content: "1200" },
        { vmid: "og:image", property: "og:image", content: 'https:' + ogImage }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.website-external-wrapper {
  background: linear-gradient(90deg, rgba(240,240,235,1) 0%, rgba(255,255,255,1) 35%, rgba(240,240,235,1) 100%);
  background: white;
}
.full-area {
  background: transparent;
}
</style>
